import React from 'react';
import { toSafeHttpHref, URL_PATTERN } from './urlUtils';

/**
 * Render a single line with **bold** and inline http(s) links.
 */
export function formatLine(line, lineIndex) {
  const parts = [];
  const urlMatches = [];
  let match;
  const urlRegex = new RegExp(URL_PATTERN.source, 'gi');

  while ((match = urlRegex.exec(line)) !== null) {
    const safeHref = toSafeHttpHref(match[0]);
    if (!safeHref) continue;
    urlMatches.push({
      start: match.index,
      end: match.index + match[0].length,
      url: safeHref
    });
  }

  const boldPattern = /\*\*(.*?)\*\*/g;
  const boldMatches = [];
  while ((match = boldPattern.exec(line)) !== null) {
    boldMatches.push({
      start: match.index,
      end: match.index + match[0].length,
      text: match[1]
    });
  }

  const allMatches = [
    ...urlMatches.map((m) => ({ ...m, type: 'url' })),
    ...boldMatches.map((m) => ({ ...m, type: 'bold' }))
  ].sort((a, b) => a.start - b.start);

  let currentIndex = 0;

  allMatches.forEach((item, idx) => {
    if (item.start > currentIndex) {
      const beforeText = line.substring(currentIndex, item.start);
      if (beforeText) {
        parts.push(<span key={`text-${lineIndex}-${idx}`}>{beforeText}</span>);
      }
    }

    if (item.type === 'url') {
      parts.push(
        <a
          key={`link-${lineIndex}-${idx}`}
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          className="message-link"
          onClick={(e) => e.stopPropagation()}
        >
          {line.substring(item.start, item.end)}
        </a>
      );
    } else if (item.type === 'bold') {
      parts.push(<strong key={`bold-${lineIndex}-${idx}`}>{item.text}</strong>);
    }

    currentIndex = item.end;
  });

  if (currentIndex < line.length) {
    const remainingText = line.substring(currentIndex);
    if (remainingText) {
      parts.push(<span key={`text-${lineIndex}-end`}>{remainingText}</span>);
    }
  }

  if (parts.length === 0) {
    const urlMatch = line.match(URL_PATTERN);
    if (urlMatch) {
      const url = toSafeHttpHref(urlMatch[0]);
      if (url) {
        const beforeUrl = line.substring(0, urlMatch.index);
        const afterUrl = line.substring(urlMatch.index + urlMatch[0].length);
        return (
          <>
            {beforeUrl && <span>{beforeUrl}</span>}
            <a href={url} target="_blank" rel="noopener noreferrer" className="message-link">
              {urlMatch[0]}
            </a>
            {afterUrl && <span>{afterUrl}</span>}
          </>
        );
      }
    }
    return <span>{line}</span>;
  }

  return <>{parts}</>;
}
